<div class="p-4  bg-white">
  <h2 class="text-xl font-bold mb-4">Material Master - {{ mode | titlecase }} Mode</h2>

  <div class="mb-4 flex gap-2">
    <button mat-stroked-button color="primary" *ngIf="mode === 'view'" (click)="setMode('edit')">Edit</button>
    <button mat-stroked-button color="accent" *ngIf="mode === 'edit'" (click)="setMode('view')">Cancel</button>
  </div>

  <form [formGroup]="materialForm" (ngSubmit)="onSubmit()"
    class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white p-6 rounded-lg shadow" novalidate>
    <div>
      <mat-label>Company</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="company" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>

    <div>
      <mat-label>Contact Name</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="contactName" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Phone</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="phone" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Email</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="email" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Type of Material</mat-label>

      <mat-form-field appearance="outline">
        <mat-select formControlName="materialType" [disabled]="mode === 'view'">
          <mat-option value="Consumable">Consumable</mat-option>
          <mat-option value="Non-consumable">Non-consumable</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Material Name</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="materialName" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Supplier Part Number</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="supplierPartNumber" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Client Part Number</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="clientPartNumber" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Machine Reference</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="machineReference" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>UOM</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="uom" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Store Keeper</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="storeKeeper" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Safety Certificate No.</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="safetyCertNo" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>License No.</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="licenseNo" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Location of Storage</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="storageLocation" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Quantity</mat-label>

      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="qty" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Consumption per meter</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="consumptionPerMeter" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Expiry Date</mat-label>

      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="picker1" formControlName="expiryDate" [readonly]="mode === 'view'">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Storage Instructions</mat-label>

      <mat-form-field appearance="outline">
        <textarea matInput formControlName="storageInstructions" [readonly]="mode === 'view'"></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Min Order Level</mat-label>

      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="minOrderLevel" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Min Reorder Qty</mat-label>

      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="minReorderQty" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Lead Time</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="leadTime" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Daily Consumption Pattern</mat-label>

      <mat-form-field appearance="outline">
        <textarea matInput formControlName="dailyConsumptionPattern" [readonly]="mode === 'view'"></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Cost per Unit</mat-label>

      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="costPerUnit" [readonly]="mode === 'view'">
      </mat-form-field>
    </div>

    <div class="col-span-2 flex justify-end mt-4" *ngIf="mode !== 'view'">
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>
  </form>
</div>